import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import ApplicationsList from "./ApplicationsList";
import EditApplication from "./EditApplication";
import { addApplication } from "services/applicationService";

const Applications = (props) => {
  const [isAddFormOpen, setIsAddFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      await addApplication({
        active: data.active ?? true,
        ...data,
      });
      setIsAddFormOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn p-0`}
          onClick={() => {
            setIsAddFormOpen(true);
          }}
        >
          Add <br />
          Application
        </Button>
      </div>

      <div className="flex-grow-1 settings-grid-wrapper mb-2" style={{ minHeight: 0 }}>
        <ApplicationsList />
      </div>

      {isAddFormOpen && (
        <EditApplication
          cancelEdit={() => setIsAddFormOpen(false)}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default Applications;
